"use client";
import { IExpoTrackParamsRecord, EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25157";
import CDNImage from "@/components/cdnImage/cdnImage";
import styles from "../index.module.scss";
import { ShopInfoVO } from "@/app/s/components/ShopBanner/type";
import SafeLink from "@/components/SafeLink";
interface ShopBannerPositionProps {
  commonTracks: {
    keyword: string;
    categoryId: string;
    logid: string;
    pvid: string;
    mtest: string;
    channelName: string;
  };
  shopInfoVO: ShopInfoVO;
  isStandalone?: boolean;
}

export default function ShopBannerPosition({ commonTracks, shopInfoVO, isStandalone = false }: ShopBannerPositionProps) {
  return (
    <SafeLink href={`/store/${shopInfoVO?.shopId}`}>
      <div
        className={isStandalone ? styles.shopBannerPositionBox : styles.shopBannerPosition}
        exptag={"exp|" + EXPOSURE_RECORD.Search_ProductList_Shop}
        data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}'
        data-exptag-json-param={JSON.stringify({
          ...commonTracks,
          shopid: shopInfoVO?.shopId || "-100",
          adDesc: shopInfoVO?.slogan || "",
          sellPoint: shopInfoVO?.shopEcommerceMerchantMindInfos?.map((item) => item.text).join(", ") || "",
        } as IExpoTrackParamsRecord["Search_ProductList_Shop"])}
        onClick={() => {
          sendClickTrack.Search_ProductList_Shop_Entry_Button({
            ...commonTracks,
            shopid: shopInfoVO?.shopId || "-100",
            adDesc: shopInfoVO?.slogan || "",
            sellPoint: shopInfoVO?.shopEcommerceMerchantMindInfos?.map((item) => item.text).join(", ") || "",
          });
        }}
      >
        <div className={styles.shopBannerPositionLeft}>
          <div>
            <CDNImage src={shopInfoVO?.logoUrl || ""} width={60} height={60} style={{ width: 60, height: 60 }} />
          </div>
          <div className={styles.shopDetail}>
            <div className={styles.shopName}>{shopInfoVO?.shopName}</div>
            <div className={styles.shopDescription}>{shopInfoVO?.slogan}</div>
          </div>
        </div>
        <div className={styles.shopBannerPositionRight}>
          {shopInfoVO?.shopEcommerceMerchantMindInfos?.map((item) => (
            <div key={item.text} className={styles.shopBannerPositionRightItem}>
              <div>
                <CDNImage src={item.icon} errorImgType={1} width={24} height={24} alt={item.text} style={{ width: 24, height: 24 }} />
              </div>
              <div className={styles.benefitPointBox}>{item.text}</div>
            </div>
          )) ?? []}
        </div>
      </div>
    </SafeLink>
  );
}
